import store from "@/store";
import type { AxiosRequestConfig, InternalAxiosRequestConfig } from "axios";

/**
 * Request interceptor to add authentication token and handle FormData
 */
export const requestInterceptor = {
  onFulfilled: (request: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const token = store.getters.sessionToken;
    if (token) {
      request.headers.Authorization = `Bearer ${token}`;
    }

    // Remove Content-Type header for FormData
    if (request.data instanceof FormData) {
      delete request.headers["Content-Type"];
    }

    return request;
  },
  onRejected: (error: unknown) => {
    return Promise.reject(error);
  },
};
